<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form action="#">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: 'subscriberDetail', params: {id: entity.id_subscriber, tab: 'profiles'} }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <h1 v-translate>Nový profil odběratele</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content" id="tab-1">
          <BasicInfo
              :profile="entity"
              :isEditable="isEditable"
          />
          <section class="buttons">
            <p>
              <router-link :to="{ name: 'subscriberDetail', params: {id: entity.id_subscriber, tab: 'profiles'} }" class="btn btn_back btn_seznam" v-translate>Seznam</router-link>
              <input
                  v-if="isEditable"
                  type="submit"
                  :value="'Uložit' | translate"
                  :class="['btn']"
                  @click.prevent.stop="createEntity()">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"
import subscriberProfile from "./mixins/subscriberProfile";
import SelectImagePopup from "./SelectImagePopup.vue";
import BasicInfo from "./forms/BasicInfo.vue";

export default {
  name: "SubscriberProfileDetail",
  components: {SelectImagePopup, BasicInfo},
  mixins: [detailActions, subscriberProfile],
  data() {
    return {
      entityName: 'subscriber_profile',
      detailPageRouteName: 'subscriberProfileDetail',
      entity: {
        id_subscriber: this.$route.params['idSubscriber'],
      }
    }
  },
  created(SubscriberProfileService) {
    this.entityService = SubscriberProfileService;
    this.entityService.getImageList()
        .then((data)=>{
          this.entity.image = data['list'][0]['name'];
          this.entity.image_path = data['list'][0]['path'];
        });
  },
  computed: {
    isEditable(){
      return this.$_loggedUser_action_allowed(this.$route.meta.sectionName, 'update');
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscriberProfile/SubscriberProfileNew.vue